import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Container,
    Card,
    Typography,
    CardContent,
    CardActions,
    Button,
    Modal,
    Backdrop,
    Fade
} from '@material-ui/core'

const styles = makeStyles((theme) =>({
    card: {
        margin : '1rem',
       
        [theme.breakpoints.up('md')]: {
            marginBottom : '7.6rem'
        }
    },
    descripcion : {
        margin: '.5rem',
        textTransform : 'uppercase'
    },
    titulo : {
        textTransform : 'uppercase',
        textAlign : 'center'
    },
    botonera : {
        width:'100%',
        display : 'flex',
        justifyContent: 'space-between',
        textAlign: 'center',
       
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
      },
}));

const VerPëdido = (props) => {
    //PROPS
    const {pedido , eliminarPedido,setisloading} = props
    //STATE
    const [open, setopen] = useState(false);
    
    //FUNCIONES
  
    const onHandleClose = () => {
        setopen(false)
    }
    const handleDelete = async pedido => {
        setisloading(true)
        await eliminarPedido(pedido)
        setopen(false)
        setisloading(false)
    }
    const classes = styles()
    return (  
        
        <Container maxWidth="sm">
                <Card  variant="outlined" className = {classes.card}>
                    <CardContent>
                        <Typography  color="textSecondary" align='center' variant='h4' gutterBottom>
                            Mi pedido
                        </Typography>
                        <Typography variant="h5" component="h2">
     
                        </Typography>
                        {pedido ? 
                            pedido.status === false ? (<>
                                <Typography display="block">Estado del Pedido:</Typography> 
                                <Typography display="block" color="secondary" className={classes.descripcion}> {pedido.enCamino === false ? "En elaboracion" : "En camino"}</Typography>
                                <Typography display="block">Pago:</Typography>
                                <Typography display="block" color="secondary" className={classes.descripcion}>{pedido.pago === false ? "No" : "Si"}</Typography>
                                <Typography display="block">Forma de entrega: </Typography>
                                <Typography display="block" color="secondary" className={classes.descripcion}>{pedido.tipo}</Typography>
                                {pedido.tipo === "domicilio" ? <>
                                                <Typography display="block">Lugar de entrega:</Typography>
                                                <Typography display="block" color="secondary" className={classes.descripcion}>{pedido.domicilio} ({pedido.barrio})</Typography>
                                                {pedido.barrio === "san carlos" ? <Typography display="block" color="textSecondary">*Recuerde que el envio a su zona se realiza despues de las 21 horas</Typography>: null}
                                                </>
                                : null}
                                    {pedido.menu ? pedido.menu.map(menu =>{
                                        return  <Card  key= {menu._id} className = {classes.card}>
                                                <CardContent>
                                                    <Typography variant="h5" component="h2" className={classes.titulo}>
                                                        {menu.platos.nombre}
                                                    </Typography>
                                                    <Typography  color="textSecondary">
                                                             Ingredientes:
                                                    </Typography>
                                                    {menu.ingredientes.map(ingre =>{
                                                        return <Typography key ={ingre._id}variant="body2" component="p" className={classes.descripcion}>
                                                                    { ingre.nombre }
                                                                </Typography>
                                                        })}
                             
                                                    <Typography  color="textSecondary">
                                                        Bebidas:
                                                    </Typography>
                                                        {menu.bebidas.map(bebida =>{
                                                            return <Typography key = {bebida._id} variant="body2" component="p" className={classes.descripcion}>
                                                                        { bebida.nombre}
                                                                    </Typography>
                                                            })}
                                                    
                                                </CardContent>
                                   
                                                </Card> })
                                
                                    : null}
                                
                                                    </>
                            ) : null
                        
                        : (
                        <Typography color="textSecondary">
                            No hay pedido en curso
                        </Typography> 
                        )}
                    </CardContent>
                    <CardActions>
                        {pedido ? 
                        <div className={classes.botonera}>
                            <div><Button size="medium" variant="outlined" color="secondary" href="https://api.whatsapp.com/send?phone=+5492236967193">Tengo un problema</Button></div>
                            
                        </div> : null}
                        
                    </CardActions>
                </Card>
                <div>
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        className={classes.modal}
                        open={open}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                        timeout: 500,
                        }}
                    >
                    <Fade in={open}>
                        <div className={classes.paper}>
                            <h2 id="transition-modal-title">Eliminar Pedido</h2>
                            <p id="transition-modal-description">Realmente quiere cancelar su pedido?</p>
                            <div className={classes.botonera}>
                            <div><Button size="medium" variant="outlined" color="secondary" onClick={onHandleClose}>Cancelar</Button></div>
                            <div><Button size="medium" variant="outlined" color="primary" onClick={() => handleDelete(pedido)}>Eliminar Pedido</Button></div>
                        </div> 
                        </div>
                       
                    </Fade>
                    </Modal>
                </div>
        </Container>
    );
}
 
export default VerPëdido;
